import { Platform } from '@ionic/angular';
import { IKeyStorage } from './key-manager';
import { KeyStorageWebService } from '../services/key-storage-web.service';


export function keyStorageFactory(platform: Platform): IKeyStorage {
  if (platform.is('capacitor') || platform.is('cordova')) {
   // console.log('not supporting mobile phones');
    return null;
  } else {
   // console.log('🌐 Using web key storage');
    return new KeyStorageWebService();
  }
}